import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';

export function AdminPortalLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login } = useAdminAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/admin');
    } catch (err: any) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f6f8f7] font-sans p-6 selection:bg-teal-200">
      <div className="bg-white p-10 rounded-[2.5rem] shadow-xl shadow-slate-200/50 max-w-[440px] w-full border border-slate-200/60">
        <div className="flex flex-col items-center mb-10">
          <img src="/taplo-wordmark.png" alt="Taplo" className="h-10 md:h-12 mb-4 select-none" draggable={false} />
          <h1 className="m-0 text-2xl font-extrabold text-slate-900 tracking-tight">Platform Admin</h1>
          <p className="mt-2 text-[15px] font-medium text-slate-500 text-center">
            Manage tenants and invitations
          </p>
        </div>

        {error && (
          <div className="px-4 py-3 bg-red-50 text-red-600 border border-red-100 rounded-2xl mb-6 text-sm font-medium">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="flex flex-col gap-5">
          <div>
            <label className="block text-[13px] font-bold text-slate-500 uppercase tracking-wide mb-2 ml-1">Email</label>
            <input
              className="w-full h-14 px-5 bg-white border border-slate-200 rounded-2xl text-[16px] text-slate-800 font-medium focus:outline-none focus:border-slate-900 focus:ring-1 focus:ring-slate-900 transition-all placeholder-slate-300"
              type="email"
              placeholder="admin@example.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div>
            <label className="block text-[13px] font-bold text-slate-500 uppercase tracking-wide mb-2 ml-1">Password</label>
            <input
              className="w-full h-14 px-5 bg-white border border-slate-200 rounded-2xl text-[16px] text-slate-800 font-medium focus:outline-none focus:border-slate-900 focus:ring-1 focus:ring-slate-900 transition-all placeholder-slate-300"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className={`w-full h-14 mt-3 rounded-2xl flex items-center justify-center text-[16px] font-bold transition-all ${
              loading
                ? 'bg-slate-100 text-slate-400 cursor-not-allowed'
                : 'bg-slate-900 text-white shadow-lg shadow-slate-900/20 hover:bg-black active:scale-[0.98]'
            }`}
          >
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
